export default __webpack_public_path__ + "static/r4-ab7fc061707426372b13c38451244f46.png";